<ng-template
  #itemTemplate
  let-item="item"
  let-onCollapseExpand="onCollapseExpand"
  let-onCheckedChange="onCheckedChange"
>
  <div class="form-check" [class.selected-catalog]="item.checked">
    <label class="form-check-label">
      <span
        [id]="item.value"
        *ngIf="!item.children"
        style="cursor: pointer"
        [ngClass]="{ active: item.checked }"
        (click)="multiSelect(item)"
      >
        {{ item.text }}</span
      >
    </label>
  </div>
</ng-template>

<div *ngIf="items">
  <div class="form-group">
    <div class="dropdown root-dropdown" dropdown placement="bottom right" [isOpen]="status.isopen">
      <div
        id="dLabel2"
        class="btn-white-sm btn dropdown-toggle tree-view-selector"
        type="button"
        data-toggle="dropdown"
        role="button"
        dropdownToggle
        aria-haspopup="true"
        aria-expanded="false"
      >
        <div class="categories-selector">
          <span *ngIf="selectedItems.length === 0">{{ displayText }}</span>
          <span *ngFor="let selected of selectedItems">{{ selected.text }}</span>
        </div>
        <span class="caret pull-right"></span>
      </div>
      <i *ngIf="allowClear && selectedItems.length >= 1" class="fa fa-close" (click)="clearTreeview()"></i>
      <div *dropdownMenu class="dropdown-menu" aria-labelledby="dLabel2" (click)="$event.stopPropagation()">
        <div class="dropdown-container d-inline-block">
          <ngx-treeview
            [config]="config"
            [items]="items"
            [headerTemplate]="headerTemplate"
            [itemTemplate]="itemTemplate"
          >
          </ngx-treeview>
        </div>
      </div>
    </div>
  </div>
</div>
